import React from 'react';
import { Avatar, makeStyles } from "@fluentui/react-components";
import {
  AppItem,
  NavCategory,
  NavCategoryItem,
  NavDrawer,
  NavDrawerBody,
  NavItem,
  NavSubItem,
  NavSubItemGroup,
} from "@fluentui/react-components";
import { ChannelAdd24Regular, Home24Regular, People24Regular, SignOut24Regular, History24Regular } from '@fluentui/react-icons';
import { useNavigate, useLocation } from 'react-router';
import { useMsal } from '@azure/msal-react';

const useStyles = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    height: "100vh",
    float: "left",
    maxWidth: "260px"
  },
  navAvatar: {
    textTransform: "capitalize"
  },
  logo: {
    width: '160px',
    height: 'auto',
    marginBottom: '25px'
  }
});

/**
 * Navbar component. Designed to look like the Navbar in MBEWeb but doesn't do
 * much.
 */
interface INavbar {
  licenseCloudUser: string;
}

export const NavbarComponent = (props: INavbar) => {
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { instance } = useMsal();
  
  let selectedValue = 0;
  if (location?.pathname === '/') {
    selectedValue = 1;
  } else if (location.pathname === '/customers/') {
    selectedValue = 3;
  } else if (location.pathname === "/addcustomer/") {
    selectedValue = 4;
  } else if (location.pathname === "/license/") {
    selectedValue = 5;
  }

  const signout = () => instance.logoutPopup();

  return (
    <div id="nav" className={styles.root}>
      <NavDrawer
        type={"inline"}
        open={true}
        backdropMotion={null}
        surfaceMotion={null}
        selectedValue={`${selectedValue}`}
      >
        <NavDrawerBody>
          <img
            className={styles.logo}
            src='/public/static/images/logo-white.png'
          />
          <AppItem
            icon={<Avatar
                name={props.licenseCloudUser}
              />
            }
          >
            <span className={styles.navAvatar}>{props.licenseCloudUser}</span>
          </AppItem>

          <NavItem icon={<Home24Regular />} value="1" onClick={() => navigate('/')}>Home</NavItem>

          <NavCategory value="2">
            <NavCategoryItem icon={<People24Regular />}>
              Customers
            </NavCategoryItem>
            <NavSubItemGroup>
              <NavSubItem value="3" onClick={() => navigate('/customers')}>Search</NavSubItem>
              <NavSubItem value="4" onClick={() => navigate('/addcustomer')}>Add Customer</NavSubItem>
            </NavSubItemGroup>
          </NavCategory>

          <NavItem icon={<ChannelAdd24Regular />} value="5" onClick={() => navigate('/licenses')}>Issue License</NavItem>
          <NavItem icon={<History24Regular />} value="6" onClick={() => navigate('/licenses/renew')}>Renew License</NavItem>

          <NavItem icon={<SignOut24Regular />} onClick={signout} value="6">
            Sign Out
          </NavItem>
          
        </NavDrawerBody>
      </NavDrawer>
    </div>
  );
};